import React from 'react';
import i18n from 'i18next';
import {
  Features,
  ProDashboard
} from '@gymcloud/core';
import {
  Tooltip
} from 'web-components';
import {
  Flex,
} from 'web-styled';

import * as S from './styled';

// Types
interface Props {
  data: ProDashboard;
  features: Features;
}

interface IconProps extends React.SVGProps<SVGSVGElement> { }

// Calendar Icons Components
const CalendarScheduled: React.FC<IconProps> = (props) => (
  <svg
    width={39}
    height={41}
    viewBox="0 0 39 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M35.6652 5.40381H3.54162C2.33855 5.40381 1.36328 6.37908 1.36328 7.58214V37.5493C1.36328 38.7523 2.33855 39.7276 3.54162 39.7276H35.6652C36.8683 39.7276 37.8436 38.7523 37.8436 37.5493V7.58214C37.8436 6.37908 36.8683 5.40381 35.6652 5.40381Z"
      fill="white"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M8.24707 1.90918V8.89732"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M30.9585 1.90918V8.89732"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M1.36328 13.0088H37.8436"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M7.98438 21.187H15.3547"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M7.98438 25.249H15.3547"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M23.7798 27.3501H31.1501"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M23.7798 31.418H31.1501"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M25.0514 20.2036L14.1543 31.1062"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

const CalendarCompleted: React.FC<IconProps> = (props) => (
  <svg
    width={40}
    height={41}
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M36.3281 5.49463H4.20446C3.0014 5.49463 2.02612 6.4699 2.02612 7.67296V37.6401C2.02612 38.8431 3.0014 39.8184 4.20446 39.8184H36.3281C37.5311 39.8184 38.5064 38.8431 38.5064 37.6401V7.67296C38.5064 6.4699 37.5311 5.49463 36.3281 5.49463Z"
      fill="white"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M8.9104 2V8.98814"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M31.6216 2V8.98814"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M2.02612 13.0996H38.5064"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path d="M12.2737 25.9453L17.6622 31.3338L28.5757 20.4258" fill="white" />
    <path
      d="M12.2737 25.9453L17.6622 31.3338L28.5757 20.4258"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

const CalendarTomorrow: React.FC<IconProps> = (props) => (
  <svg
    width={40}
    height={41}
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M36.1713 5.40381H4.04772C2.84466 5.40381 1.86938 6.37908 1.86938 7.58214V37.5493C1.86938 38.7523 2.84466 39.7276 4.04772 39.7276H36.1713C37.3744 39.7276 38.3497 38.7523 38.3497 37.5493V7.58214C38.3497 6.37908 37.3744 5.40381 36.1713 5.40381Z"
      fill="white"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M8.75342 1.90918V8.89732"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M31.4648 1.90918V8.89732"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M1.86938 13.0088H38.3497"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M8.49072 19.1289H20.1085"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M14.301 25.293H25.9188"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M18.8486 31.5381H30.4664"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

const CalendarNavigation: React.FC<IconProps> = (props) => (
  <svg
    width={39}
    height={41}
    viewBox="0 0 39 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M35.4697 5.49463H3.34606C2.143 5.49463 1.16772 6.4699 1.16772 7.67296V37.6401C1.16772 38.8431 2.143 39.8184 3.34606 39.8184H35.4697C36.6727 39.8184 37.648 38.8431 37.648 37.6401V7.67296C37.648 6.4699 36.6727 5.49463 35.4697 5.49463Z"
      fill="white"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M8.052 2V8.98814"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M30.7637 2V8.98814"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M1.16772 13.0996H37.648"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path d="M22.5369 20.8076L27.576 25.8522L22.4768 30.9513" fill="white" />
    <path
      d="M22.5369 20.8076L27.576 25.8522L22.4768 30.9513"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M11.241 25.8799H27.5757"
      stroke="#231F20"
      strokeWidth={2.18182}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

// Configuration for dashboard indicators
const DASHBOARD_INDICATORS = [
  {
    id: 'scheduled-this-week',
    icon: CalendarScheduled,
    titleKey: 'dashboard.scheduled.this.week',
    getCount: (data: ProDashboard) =>
      `${data.events_scheduled_this_week_count || 0}/${data.events_scheduled_last_week_count || 0}`,
  },
  {
    id: 'completed-this-week',
    icon: CalendarCompleted,
    titleKey: 'dashboard.client.completed.this.week',
    getCount: (data: ProDashboard) =>
      `${data.events_completed_this_week_count || 0}`,
  },
  {
    id: 'scheduled-tomorrow',
    icon: CalendarTomorrow,
    titleKey: 'dashboard.scheduled.tomorrow',
    getCount: (data: ProDashboard) =>
      `${data.events_scheduled_tomorrow_count || 0}`,
  },
] as const;

// Individual indicator item component
interface IndicatorItemProps {
  icon: React.ComponentType<IconProps>;
  title: string;
  count: string;
  children?: React.ReactNode;
}

const IndicatorItem: React.FC<IndicatorItemProps> = ({
  icon: Icon,
  title,
  count,
  children
}) => (
  <S.Item>
    <Flex column align="center">
      <Icon />
      <S.Title>{title}</S.Title>
    </Flex>
    {count && (
      <S.Count>{count}</S.Count>
    )}
    {children}
  </S.Item>
);

// Calendar navigation item component
const CalendarNavigationItem: React.FC = () => (
  <IndicatorItem
    icon={CalendarNavigation}
    title="My Calendar"
    count=""
  >
    <Tooltip
      body={i18n.t('tooltip.dashboard.calendar.button')}
      positions={['right']}
    >
      <S.Link to="/calendar">
        Go To Calendar
      </S.Link>
    </Tooltip>
  </IndicatorItem>
);

// Main component
const Indicators: React.FC<Props> = ({ data, features }) => {
  const shouldShowCalendarNavigation = features.calendar_and_scheduling;

  return (
    <S.Wrapper width={shouldShowCalendarNavigation ? '20%' : '30%'}>
      {DASHBOARD_INDICATORS.map((indicator, index) => (
        <React.Fragment key={indicator.id}>
          {index > 0 && <hr />}
          <IndicatorItem
            icon={indicator.icon}
            title={i18n.t(indicator.titleKey)}
            count={indicator.getCount(data)}
          />
        </React.Fragment>
      ))}

      {shouldShowCalendarNavigation && (
        <>
          <hr />
          <CalendarNavigationItem />
        </>
      )}
    </S.Wrapper>
  );
};

export default Indicators;
